// Core
import React, { useState, useRef, useEffect } from "react"
import { gsap } from "gsap"
import { isBrowser } from "react-device-detect"

// Components
import JsonText from "../_jsonText"
import { SlideMaskText } from "../slideMaskText"

// Style
import styles from "./programNoteItem.module.scss"

// Handle scroll height change
const updateScroll = () => isBrowser && window.scroll.update()

const collapsible = node => {
  const tl = gsap.timeline({
    defaults: {
      duration: window.innerWidth < 1024 ? 1 : 0.6,
      ease: "power3.inOut",
      onUpdate: () => updateScroll(),
    },
  })

  const animation = height =>
    tl
      .to(node, { height: height, willChange: "height" })
      .to(node, { clearProps: "willChange" }, "-=0.45")
      .pause()

  let open = () => animation("auto").play()
  let close = () => animation(0).play()

  return { open, close }
}

const ProgramNoteItem = ({ heading, subheadingRich, content, details }) => {
  const [state, setState] = useState({
    initial: false,
    clicked: null,
  })

  let body = useRef(null)

  const handleClick = () => {
    if (state.initial === false) {
      setState({
        initial: null,
        clicked: true,
      })
    } else if (state.clicked === true) {
      setState({
        clicked: !state.clicked,
      })
    } else if (state.clicked === false) {
      setState({
        clicked: !state.clicked,
      })
    }
  }

  useEffect(() => {
    if (state.clicked === false) {
      collapsible(body).close()
    } else if (
      state.clicked === true ||
      (state.clicked === true && state.initial === null)
    ) {
      collapsible(body).open()
    }
  }, [state])

  return (
    <li
      className={`${styles.item} ${state.clicked ? styles.open : ""} container`}
      onClick={handleClick}
      data-slidemasktext
    >
      <div className={styles.itemHeader}>
        <div className={styles.itemIcon}></div>
        <h4 className={styles.itemTitle}>
          <SlideMaskText text={heading} />
        </h4>
        <JsonText {...subheadingRich} />
      </div>
      <div className={styles.content} ref={el => (body = el)}>
        <div className={`${styles.contentInner} cols`}>
          <div className={`${styles.contentCol} col m12 d5 dl4`}>
            <JsonText {...content} />
          </div>
          <div className={`${styles.detailsCol} col m12 d2`}>
            <JsonText {...details} />
          </div>
        </div>
      </div>
    </li>
  )
}

export default ProgramNoteItem
